import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import DeductionChart from "./DeductionChart";
import PayrollChart from "./PayrollChart";
import TopEmployees from "./TopEmployees";
// import DeductionChart from "./DeductionChart";
// import PayrollChart from "./PayrollChart";
// import TopEmployees from "./TopEmployees";

export default function LeftDashboard(){

  return(

    <div>

      <Row className="mb-3">

        <Col md={6}>

          <Card className="p-3">

            <div className="d-flex justify-content-between">

              <div>
                <p>Benefits Deductions</p>
                <h3>$56K</h3>
                <p>Insurance + 401(k)</p>
              </div>

              <DeductionChart/>

            </div>

          </Card>

        </Col>

        <Col md={6}>

          <Card className="p-3">

            <div className="d-flex justify-content-between">

              <div>
                <p>Total Payroll</p>
                <h3>$2.4M</h3>
                <p className="text-success">+55% Increased</p>
              </div>

              <PayrollChart/>

            </div>

          </Card>

        </Col>

      </Row>

      <Card className="p-3">

        <TopEmployees/>

      </Card>

    </div>
  )
}